var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOverviewHover = function SvgOverviewHover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 20.5,
    viewBox: "0 0 25.5 20.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#ffb657;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.25 -4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,22.109A23.412,23.412,0,0,1,24.415,24,11.207,11.207,0,0,0,27,16.706,11.832,11.832,0,0,0,15,5,11.832,11.832,0,0,0,3,16.706,11.729,11.729,0,0,0,5.585,24,23.412,23.412,0,0,1,15,22.109Z",
    className: "a"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 2,
    className: "a",
    transform: "translate(15 7.918)"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.4,
    y2: 1.4,
    className: "a",
    transform: "translate(8.42 10.271)"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2,
    className: "a",
    transform: "translate(6 16.706)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    className: "a",
    transform: "translate(22 16.706)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.4,
    y2: 1.4,
    className: "a",
    transform: "translate(20.18 10.271)"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 4,
    y1: 8,
    className: "a",
    transform: "translate(14.818 13.9)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOverviewHover);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS41IiBoZWlnaHQ9IjIwLjUiIHZpZXdCb3g9IjAgMCAyNS41IDIwLjUiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOm5vbmU7c3Ryb2tlOiNmZmI2NTc7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoxLjVweH08L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4yNSAtNC4yNSkiPjxwYXRoIGQ9Ik0xNSwyMi4xMDlBMjMuNDEyLDIzLjQxMiwwLDAsMSwyNC40MTUsMjQsMTEuMjA3LDExLjIwNywwLDAsMCwyNywxNi43MDYsMTEuODMyLDExLjgzMiwwLDAsMCwxNSw1LDExLjgzMiwxMS44MzIsMCwwLDAsMywxNi43MDYsMTEuNzI5LDExLjcyOSwwLDAsMCw1LjU4NSwyNCwyMy40MTIsMjMuNDEyLDAsMCwxLDE1LDIyLjEwOVoiIGNsYXNzPSJhIi8+PGxpbmUgeTI9IjIiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNSA3LjkxOCkiLz48bGluZSB4Mj0iMS40IiB5Mj0iMS40IiBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC40MiAxMC4yNzEpIi8+PGxpbmUgeDI9IjIiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2IDE2LjcwNikiLz48bGluZSB4MT0iMiIgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyIDE2LjcwNikiLz48bGluZSB4MT0iMS40IiB5Mj0iMS40IiBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAuMTggMTAuMjcxKSIvPjxsaW5lIHgyPSI0IiB5MT0iOCIgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0LjgxOCAxMy45KSIvPjwvZz48L3N2Zz4=";